import { getAge } from 'utils/date'
import { useStores } from './useStores'
import { getAgeGroupFromAge } from 'utils/userState'

export function useAgeGroup() {
  const {
    traversal: {
      data: {
        debtors: {
          primary: {
            personal: { birthday }
          }
        }
      }
    }
  } = useStores()

  const debtorsAge = getAge(birthday)
  const ageGroup = getAgeGroupFromAge(debtorsAge)
  return ageGroup
}
